import type { ChangeEventHandler } from 'react'
import { useCallback } from 'react'
import styled from 'styled-components'
import clsx from 'clsx'
import { rem } from 'polished'
import ProductPaletteProvider from 'contexts/ProductPaletteContext'
import SwitchButton from 'LuxKit/Switch/SwitchButton'
import { FILTER_CHIP_HEIGHTS } from 'LuxKit/Chips/FilterChip'
import LuxPlusLogo from 'luxPlus/components/Logos/LuxPlusLogo'

const ToggleWrap = styled.span`
  display: inline-flex;
  flex-shrink: 0;

  /*
   * SwitchButton is fixed at the 32px medium chip height, which is right beside
   * the desktop filter chips but a head taller than the 28px small chips the
   * mobile strip uses. Trim it from out here rather than in LuxKit: the 24px
   * Switch is what sets the floor, so only the block padding gives -- 2px either
   * side instead of 4 -- and the inline padding drops to the small chip's 8px.
   */
  &.is-small > label {
    height: ${rem(FILTER_CHIP_HEIGHTS.small)};
    gap: ${rem(8)};
    padding-block: ${rem(2)};
    padding-inline: ${rem(8)} ${rem(2)};
  }
`

interface Props {
  checked: boolean
  disabled?: boolean
  onChange: () => void
  /** `small` matches the 28px mobile filter chips; `medium` the 32px desktop ones. */
  size?: 'medium' | 'small'
}

function TripListLuxPlusToggle({ checked, disabled, onChange, size = 'medium' }: Props) {
  const handleChange = useCallback<ChangeEventHandler<HTMLInputElement>>(() => {
    onChange()
  }, [onChange])

  return (
    <ProductPaletteProvider palette="lux-plus">
      <ToggleWrap
        data-testid="trip-list-lux-plus-toggle"
        className={clsx(size === 'small' && 'is-small')}
      >
        <SwitchButton
          checked={checked}
          disabled={disabled}
          onChange={handleChange}
        >
          <LuxPlusLogo inline height={10} />
        </SwitchButton>
      </ToggleWrap>
    </ProductPaletteProvider>
  )
}

export default TripListLuxPlusToggle
